<div id="alumni" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h1 class="title">Alumni Association</h1>
    <p class="inner-lead mt-3">
      The Alumni Association of Shah Satnam Ji Girls' College, Sirsa serves as a bridge between the institution and its
      former students. We are proud of our vast network of alumnae who have excelled in diverse fields and continue to
      embody the values of their alma mater.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-4">
      <!-- Portal Cards -->
      <div class="col-md-4">
        <div class="info-card text-center d-flex flex-column align-items-center py-4">
          <div class="mb-3 text-orange-color">
            <i class="fa fa-file-pdf-o fa-3x"></i>
          </div>
          <h5 class="info-card-title">Association Charter</h5>
          <p class="info-card-text mb-4">View the official rules, objectives, and committee structure of the Alumni
            Association.</p>
          <a href="assets/pdf/alumni/Alumni-ASSOCIATION-updated.pdf" target="_blank" class="pdf-download-btn mt-auto">
            View Document (PDF)
          </a>
        </div>
      </div>

      <div class="col-md-4">
        <div class="info-card text-center d-flex flex-column align-items-center py-4">
          <div class="mb-3 text-orange-color">
            <i class="fa fa-pencil-square-o fa-3x"></i>
          </div>
          <h5 class="info-card-title">Member Registration</h5>
          <p class="info-card-text mb-4">Register yourself in our official database to stay connected and receive event
            updates.</p>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScyWRDgb2phu8KVvA0o8WOe3YHFDMzs2A6LfsVQDM7AcxE4Ww/viewform?usp=header"
            target="_blank" class="pdf-download-btn mt-auto">
            Register Now
          </a>
        </div>
      </div>

      <div class="col-md-4">
        <div class="info-card text-center d-flex flex-column align-items-center py-4">
          <div class="mb-3 text-orange-color">
            <i class="fa fa-users fa-3x"></i>
          </div>
          <h5 class="info-card-title">Alumni Meet</h5>
          <p class="info-card-text mb-4">Relive your college memories and catch up with old friends at our annual alumni
            gatherings.</p>
          <a routerLink="/alumni/meet" class="pdf-download-btn mt-auto">
            View Events & Gallery
          </a>
        </div>
      </div>
    </div>

    <div class="mt-section text-center">
      <h4 class="section-subtitle-orange">“From Alma Mater to Ascending to Zenith”</h4>
      <p class="inner-lead">We encourage our alumni to collaborate, mentor current students, and share their
        professional
        journeys to inspire the next generation.</p>
    </div>

  </div>
</div>